<template>
  <dl v-if="coverages" :data-qa="id">
    <template v-for="item in coverages" :key="item.name">
      <dt>{{ item.name }}</dt>
      <dd>
        {{ i18n.n(item.premium, 'currency') }}
      </dd>
    </template>
  </dl>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    coverages: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
}
</script>

<style lang="scss" scoped>
dl {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 0;

  > dt {
    flex: 0 0 60%;
  }
  > dd {
    font-weight: 700;
    flex: 0 0 40%;
    text-align: right;
  }
}
</style>
